<template>
  <!-- Don't drop "q-app" class -->
  <div id="q-app">
    <router-view :root="$parent.$data"
                 :parent="$parent" />
  </div>
</template>

<script>
/*
 * Root component
 */
export default {};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/App.vue